import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { SupportLinks } from '/src/support';
import { SupportLink } from '../../_global/components/SupportLink';

export function ManualInstructions({ techOptions = [], selectedTechOption = null, onSelectTech, onContactDeveloper }) {
  const [accSegment1, accSegment2] = useAccountNumber(true);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <p className="text-sm sm:text-base font-normal tracking-[-0.008em] leading-6 text-black-pearl-500 mb-3">
        {`To install Crazy Egg, place the script at the top of the <head> section after any <meta> tags.`}
      </p>

      <CodeSnippet
        code={`<script type="text/javascript" src="//script.crazyegg.com/pages/scripts/${accSegment1}/${accSegment2}.js" async="async"></script>`}
        showMailButton
        onMailButtonClick={onContactDeveloper}
      />

      <div className="flex flex-col gap-1 mt-5">
        <SupportLink
          href={SupportLinks.install.manual}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          How do I install the tracking script?
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>
    </Card>
  );
}
